import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTimes } from '@fortawesome/pro-solid-svg-icons';

import FilterEditModal from './filter_edit_modal';
import PluginFilterType from '../types/plugin_filter_type';

export default class FilterRow extends React.Component {
  static propTypes = {
    filterFieldOptions: PropTypes.object.isRequired,
    filterModel: PluginFilterType,
    propertyTypes: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired
  };

  state = {
    showEditModal: !!this.props.filterModel.isNew
  }

  currentFieldOption() {
    return this.props.filterFieldOptions[this.props.filterModel.filterField];
  }

  sampleText() {
    return this.currentFieldOption().sample;
  }

  destroyRow = () => {
    this.props.onUpdate(this.props.filterModel.id, "_destroy", true);
  }

  showEditModal = () => {
    this.setState({ showEditModal: true });
  }

  hideEditModal = () => {
    this.setState({ showEditModal: false });
  }

  onUpdate = (key, newVal) => {
    this.props.onUpdate(this.props.filterModel.id, key, newVal);
  }

  filterLabel = () => {
    return this.currentFieldOption().label;
  }

  render() {
    return (
      <React.Fragment>
        <FilterEditModal
          fieldConfig={this.currentFieldOption()}
          filterFieldOptions={this.props.filterFieldOptions}
          filterModel={this.props.filterModel}
          propertyTypes={this.props.propertyTypes}
          show={this.state.showEditModal}
          onClose={this.hideEditModal}
          onUpdate={this.onUpdate}
        />
        <td className="w-25">
          <p className="fw-semibold my-2">
            {this.filterLabel()}
          </p>
        </td>
        <td className="w-50">
          <span className="text-muted me-2">PREVIEW:</span>
          <span>{this.sampleText()}</span>
        </td>
        <td className="w-25 text-end">
          <a
            className="me-8"
            href="#"
            name="show-edit-modal"
            onClick={(e) => {
              e.preventDefault();
              this.showEditModal();
            }}
          >
            <FontAwesomeIcon icon={faPencilAlt}/> Edit
          </a>
          <a
            className="text-danger"
            href="#"
            name="delete-row"
            onClick={(e) => {
              e.preventDefault();
              this.destroyRow();
            }}
          >
            <FontAwesomeIcon icon={faTimes}/> Delete
          </a>
        </td>
      </React.Fragment>
    );
  }
}
